

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';
import {FormControl, FormGroup, FormBuilder} from "@angular/forms";
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import { HttpClient } from '@angular/common/http';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog'
import { Inject} from '@angular/core';
import Swal from 'sweetalert2';
import { request } from 'http';
import * as backInter from 'app/auth/auth-data.model';
import { Colaboradores35Service } from 'app/main/wizard-n35/services/colaboradores35.service';
import { FormArray } from '@angular/forms';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import { fuseAnimations } from '@fuse/animations';
import *  as $ from 'jquery';
const longText = `Mega Man X, known in Japan as Rockman X,[a] is an action-platform video game developed and published by Capcom for the Super Nintendo Entertainment System (SNES).
  1
  2
  3`;
import {TranslateService} from '@ngx-translate/core';
import { Subject } from 'rxjs';
  ///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

export interface DialogData {
  opcion: any;
  //name: string;
}
@Component({
  selector: 'colaboradores',
  templateUrl: './colaboradores.component.html',
  styleUrls: ['./colaboradores.component.scss']
})
export class ColaboradoresComponent implements OnInit {

  mensajesTraducirKeys: string[] = [
    'WIZARD.MENSAJES.ADVICE1',
    'WIZARD.MENSAJES.ADVICE2',
    'WIZARD.MENSAJES.ADVICE3',
    'WIZARD.MENSAJES.ADVICE4',
    'WIZARD.MENSAJES.ADVICE5',
    'WIZARD.MENSAJES.ADVICE6',
    'WIZARD.MENSAJES.ADVICE7',
    'WIZARD.MENSAJES.ADVICE8',
    'WIZARD.MENSAJES.ADVICE9',
    'WIZARD.MENSAJES.ADVICE10',
    'WIZARD.MENSAJES.ADVICE11',
    'WIZARD.MENSAJES.ADVICE12',
    'WIZARD.MENSAJES.ADVICE13',
    'WIZARD.MENSAJES.ADVICE14',
  ];

  mensajesTraducirTS = {
    guarda_1: '',
    guarda_2: '',
    guarda_3: '',
    guarda_4: '',
    guarda_5: '',
    guarda_6: '',
    guarda_7: '',
    guarda_8: '',
    guarda_9: '',
    guarda_10: '',
    guarda_11: '',
    guarda_12: '',
    guarda_13: '',
    guarda_14: ''
  };
  private _unsubscribeAll: Subject<any>;
  productoCertificar: backInter.prodNorma35;
  opcTask: string[] = ['Cumple','No Aplica'];

  @Input() inputArray: Array<any>[];
  myForm: FormGroup;
  // INICIO DE AUTISZE
  public longText = longText;
  public minRows = 3;
  public maxRows = 10;
  public onlyGrow = true;
  public useImportant = true;

  @Output() idPreguntaBorrar: EventEmitter<number> = new EventEmitter();
  @Output() mensajeSnack: EventEmitter<any> = new EventEmitter();
  @Output() mensajeSwal: EventEmitter<any> = new EventEmitter();
  reactiveText = new FormControl(longText);
  reactiveForm = new FormGroup({
    reactiveText: new FormControl(longText)
  });
   // FIN AUTOSIZE
   pathTmp= "http://35.232.140.117/surveyadministrator/backend/";
  lado = 4;
  checked : any;
  Estadopos=true;
  Estadoneg=false;
  dataId : any ;
  master35:any;
  statusmater=false;
  primaryTask: any;
  //files:any;
  dataFilePrimary:any;
   //Variable que bloquea el select|| Manda Alerta celda vacia
   validadorMatSelect: boolean[] = [];
   validadorMatArchivo: boolean[] = [];
   fieldArrayTask2: Array<any> = [];
   newAttributeTas2k: any = {};
  constructor(private activated: ActivatedRoute,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private wizardService: WizardService,
    private colaboradoresService: Colaboradores35Service,
    private idiomasService: IdiomasServiceN35, private formBuilder: FormBuilder,
    private httpClient: HttpClient, private http: HttpClient, private fb: FormBuilder,
    private translateSrv: TranslateService,
    public dialog: MatDialog
    ) {
      this.obtieneCertificarActual();
      this._unsubscribeAll = new Subject();
      lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
  }
  InfoTabla :any;
  requerimientoTmp:any;
  idiomaBanner:any;
  fechaCertificar:any;
  idiomaActual:string;
  ngOnInit() {
    this.traduceTextosTS();
    this.InfoTabla = this.sendInfoTable("Obligaciones patrón");
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
    this.getMaster();
  }

  traduceTextosTS(){
    let iter = 0;
    for(var k in this.mensajesTraducirTS){
      this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
        this.mensajesTraducirTS[k] = res;
      });
      iter++;
    }
    this.idiomaActual = this.translateSrv.currentLang;
  }

  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaCertificar=this.productoCertificar.fechaNorma35;
              throw BreakException;
            }
          }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  cambiaIdiomaBanner(idioma:string){
    this.traduceTextosTS();
    this.idiomaBanner = this.translateSrv.currentLang;
    switch(idioma){
      case 'es': this.idiomaBanner = idioma;
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-22.png';
  }

  getMaster(){
    this.master35=this.idiomasService.getIDempresa();
    if(this.idiomasService.getIDempresa()== '5dee81f1c3d12b0d425ab8d1' || this.idiomasService.getIDempresa() =='5e87bf11d6642714933d567b'){
      this.statusmater=true;
    }
  }


  updateReactiveText() {
    const current = this.reactiveText.value;
    this.reactiveText.setValue(current + "");
  }

  updateReactiveFormText() {
    const current = this.reactiveForm.value.reactiveText;
    this.reactiveForm.setValue({
        reactiveText: current + " "
    });
  }

  typeEvent: string;
  data:any;
  private firtsSave(event,tipo,nameSeccion){
    //console.log("entro");
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.typeEvent = event.target.value;
      this.data = {
        fechaDocumentador: this.fechaCertificar,
        numeroTabla: "1",
        nombreSeccion: nameSeccion,
        requerimiento: this.typeEvent,
      };
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {

    });
  }
  fechaDocumentador_P:any;
  ObjTmp:any;
  idSeccionTmp:any;
  nombreSeccionTmp:any;
  files: any = [];

  private sendInfoTable(tittle){
    this.fechaDocumentador_P = 2019;
    let Objtamanio: any;
    let i:0;
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaDocumentador_P=this.productoCertificar.fechaNorma35;
              // Inicio de función
              this.idiomasService.getStepsData(this.fechaDocumentador_P).subscribe(( data:any )=>{
                if(data.message=="Success"){
                    var dataAux:any[]=[];
                    for(i=0; i<data.secciones.length; i++){
                      if(data.secciones[i].nombreSeccion==tittle){
                        console.log("Sección");
                        console.log(data.secciones[i]);
                        this.ObjTmp=data.secciones[i];
                        this.idSeccionTmp = data.secciones[i]._id;
                        this.getAllPrimaryTask(this.idSeccionTmp); // Files Task
                        this.nombreSeccionTmp = data.secciones[i].nombreSeccion;
                        this.requerimientoTmp = data.secciones[i].detalleControl.requerimiento;
                      }
                    }
                }
              });
              // fin de función
              throw BreakException;
            }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  private getAllPrimaryTask(seccionId){
    this.data = {
      seccionId: seccionId,
      fechaDocumentador: this.fechaCertificar
    }
    this.idiomasService.getTareasPrimaria(this.data).subscribe((data : any)=>{

        var fechaTask;
        var fechfechaTaskFin;
        this.primaryTask = data.tareas;
        this.validadorMatArchivo=[this.primaryTask.length];
        this.validadorMatSelect=[this.primaryTask.length];
        for(var p=0; p < this.primaryTask.length; p++){
          if(this.primaryTask[p].estatus){}else{
            this.primaryTask[p].estatus="No cumple";
          }
          var dataAux:any[]=[];
          this.files.push(dataAux);
          var currentDateTimeCentralTimeZone = new Date(this.primaryTask[p].fechaFin.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
          var date = new Date(currentDateTimeCentralTimeZone),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
          var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;
         // Fin prueba
          fechaTask=this.primaryTask[p].fechaCreacion.toString();
          fechfechaTaskFin=this.primaryTask[p].fechaFin.toString();
          this.primaryTask[p].fechaCreacion=fechaTask.substr(2,8);
          // this.primaryTask[p].fechaFin=fechfechaTaskFin.substr(2,8);
          this.primaryTask[p].fechaFin=dateTmp;
          this.primaryTask[p]._id;

        if(this.primaryTask[p].archivos.length >0){
          this.validadorMatArchivo[p]=false;
        }
        else{
          this.validadorMatArchivo[p]=true;
        }
        if(this.primaryTask[p].observaciones){
          if(this.primaryTask[p].observaciones.length > 0){
            this.validadorMatSelect[p]=false;
          }
          else {
            this.validadorMatSelect[p]=true;
          }
        }else{
          this.validadorMatSelect[p]=true;
        }
        this.dataFilePrimary = {
          // Archivos
            seccionId: seccionId,
            tareaId: this.primaryTask[p]._id,
            fechaDocumentador: this.fechaCertificar,
          };
        }
    });
  }



  onBlurPractica(event,idTable,tipo){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.data = {
      idSeccion : idTable,
      fechaDocumentador: this.fechaCertificar,
      numeroTabla: "1",
      nombreSeccion: 'Obligaciones patrón',
      requerimiento: ""+this.typeEvent,
    };
    console.log(this.data);
    this.idiomasService.guardaDatosStep5(this.data).subscribe( (data : any) => {
      console.log(data);
    });
  }
  dataTaskprimary:any;
  IdPrimarytaskTmpFirtsSave: any;
  PrimaryTaskTmpFirts: any

  activarAlertaob(k:number){
    if(this.validadorMatSelect[k]){
    Swal.fire({
      icon: 'warning',
      title: ''+this.mensajesTraducirTS.guarda_5, // advice 5
      confirmButtonColor: '#e40601'
    });}
  }

  addFieldValuePrimaryTask(idseccion) { // Función para agregar nuevas tareas
    Swal.fire({
      width: '550px',
      title: ''+this.mensajesTraducirTS.guarda_14, // advice 4
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.mensajesTraducirTS.guarda_13 ,
      cancelButtonText: ''+this.mensajesTraducirTS.guarda_12, // advice 4
    }).then((result) => {
      if (result.value) {
        this.fieldArrayTask2.push(this.newAttributeTas2k);
        this.newAttributeTas2k= {};
        this.dataTaskprimary = {
          idSeccion : idseccion,
          fechaDocumentador: this.fechaCertificar,
        };
          this.idiomasService.SaveTareaPrimaria(this.dataTaskprimary).subscribe((data : any) => {
            this.PrimaryTaskTmpFirts=data.tarea;
            this.IdPrimarytaskTmpFirtsSave=this.PrimaryTaskTmpFirts._id;
         });
      }
    })
  }

  private onPrimaryTask(event,idseccion,idTarea,tipo){
    this.typeEvent = event.target.value;
    if(this.typeEvent.length == 0 ){
      this.typeEvent = " ";
    }
    this.data = {
      idSeccion : idseccion,
      idTarea: idTarea,
      fechaDocumentador: this.fechaCertificar,
      descripcion: this.typeEvent,
      estatus: "No cumple",
    };

      this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
        if(tipo==2){
          this.fieldArrayTask2.splice(0, 1);
          let dataIdarch = {
            seccionId: idseccion,
            fechaDocumentador: this.fechaCertificar
          }
          this.actualizarTareas(dataIdarch);
        }
        console.log(data);
      });
  }

  private doStatus(datoOpc,idSeccionTmp,idTarea,index,k,observaciones,archivos,tamanio){
    console.log("entro");

    let id;
    let cumple = false;
    if($("#"+idTarea+"-5").val().length==0 )
     {
       Swal.fire({
         icon: 'warning',
         title: ''+this.mensajesTraducirTS.guarda_5,
         confirmButtonColor: '#e40601'
       });
     }
     else {
      Swal.fire({
        title: ''+this.mensajesTraducirTS.guarda_6,
        allowOutsideClick:false,
        didOpen: () => {
          Swal.showLoading()
        }
      });

        if (datoOpc == "No cumple") {
          this.colorStatus(index, "#FADACE");
          cumple = true;
        }
        if (datoOpc == "No aplica") {
          this.colorStatus(index, "#FFFF00");
          cumple = true;
        }
        if (datoOpc == "Cumple") {
          if (this.primaryTask[k].archivos.length > 0) {
            this.colorStatus(index, "#E2FCC5");
            cumple = true;
          }else{
            Swal.fire({
              icon: 'warning',
              title: ''+this.mensajesTraducirTS.guarda_1,
              confirmButtonColor: '#e40601'
            });
          }
        }
        if(cumple){
          this.data = {
            idSeccion : idSeccionTmp,
            idTarea: idTarea,
            fechaDocumentador: this.fechaCertificar,
            estatus: datoOpc,
          };
          this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
            //this.enviaOrdenWizard35();
            let dataIdarch = {
              seccionId: idSeccionTmp,
              fechaDocumentador: this.fechaCertificar
            }
            this.actualizarTareas(dataIdarch);
          });
        }
    }

  }

  private colorStatus(index,nameColor){
    for (var i = 1; i < 8; i++) {
      if(index==i){
        document.getElementById(index+i).style.backgroundColor = nameColor;

      }

    }
  }
  arrayFIlesTmp: any = [];
  index_tmpFile:any
  tmpIndex_aux:any;
  uploadedFiles4:any;
  uploadFile(event,idseccion,idtarea,files,k) {
    for(let m=0; m < this.arrayFIlesTmp.length; m++){
      this.arrayFIlesTmp.pop();
    }
    this.arrayFIlesTmp=[];
    this.index_tmpFile=k;
    this.tmpIndex_aux=idtarea;
    this.uploadedFiles4 = event;
    let formData = new FormData();
    for (var i = 0; i < this.uploadedFiles4.length; i++) {
      formData.append('file',this.uploadedFiles4[i]);
    }
    formData.append("fechaDocumentador",this.fechaCertificar);
    formData.append("seccionId",idseccion);
    formData.append("tareaId",idtarea);
    this.idiomasService.saveFilesTaks(formData).subscribe( (data : any) => {
      if(data.message == "File upload"){
        Swal.fire({
          icon: 'success',
          title: ''+this.mensajesTraducirTS.guarda_7, //advice 7
          html: '<h1></h1>',
          timer: 1500
        });
        let dataIdarch = {
          seccionId: idseccion,
          fechaDocumentador: this.fechaCertificar
        }
        this.idiomasService.getTareasPrimaria(dataIdarch).subscribe((data : any)=>{
          // AQUÍ DEBES PONER EL CAMPO BOOLEAN PORQUE YA SE HA CARGADO UN ARCHIVO
          this.primaryTask=data.tareas;
          this.validadorMatArchivo=[];
          this.validadorMatSelect=[];
          for(var p=0; p < this.primaryTask.length; p++){
            if(this.primaryTask[p].estatus){}else{
              this.primaryTask[p].estatus="No cumple";
            }

            let fechaTask=this.primaryTask[p].fechaCreacion.toString();
            let fechfechaTaskFin=this.primaryTask[p].fechaFin.toString();
            var currentUtcTime = new Date(); // This is in UTC
            var currentDateTimeCentralTimeZone = new Date(this.primaryTask[p].fechaFin.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
            var date = new Date(currentDateTimeCentralTimeZone),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
            var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;

            this.primaryTask[p].fechaCreacion=fechaTask.substr(2,8);
            //this.primaryTask[p].fechaFin=fechfechaTaskFin.substr(2,8);
            this.primaryTask[p].fechaFin=dateTmp;
            if(this.primaryTask[p].archivos.length >0){
              this.validadorMatArchivo.push(false);
            }
            else{
              this.validadorMatArchivo.push(true);
            }

            if(this.primaryTask[p].observaciones==null){
              this.validadorMatSelect[p]=true;
            }else{
              if(this.primaryTask[p].observaciones.length > 0){
                this.validadorMatSelect[p]=false;
              }
              else {
                this.validadorMatSelect[p]=true;
              }
            }
          }
        });
      }else{
        Swal.fire({
          icon: 'error',
          title: ''+this.mensajesTraducirTS.guarda_3, // Advice 3
          html: '<h1></h1>',
          timer: 1500
        });
      }
    });
  }
  File_tmpaux;
  deletePrimaryFile(index,seccionid,tareaid,archivoid,archivos,k,statusTarea){
    this.File_tmpaux=archivos;
    this.data = {
     seccionId : seccionid,
     tareaId: tareaid,
     archivoId: archivoid,
     fechaDocumentador: this.fechaCertificar
   };
   if(this.File_tmpaux.length == 1 && statusTarea == 'Cumple'){
     Swal.fire({
       icon: 'warning', // advice 8
       title: ''+this.mensajesTraducirTS.guarda_8,
       html: '<h1></h1>',
       timer: 1500
     });
   }
   else{
     this.idiomasService.deletePrimaryFile(this.data).subscribe( (data : any) => {
       if(data.message == 'Successfully deleted'){
         this.File_tmpaux.splice(index, 1);
         if(this.File_tmpaux.length == 0){
           this.validadorMatArchivo[k] = true;
         }
         Swal.fire({
           title: ''+this.mensajesTraducirTS.guarda_6,
           timer: 4500,
           allowOutsideClick:false,
           didOpen: () => {
             Swal.showLoading()
           }
         });
         let dataIdarch = {
           seccionId: seccionid,
           fechaDocumentador: this.fechaCertificar
         }
         this.actualizarTareas(dataIdarch);
       }
     });
   }
 }

 activarAlertaEvi(k:number){
  if(this.validadorMatArchivo[k]){
  Swal.fire({
    icon: 'warning',
    title: ''+this.mensajesTraducirTS.guarda_1, // advice 1
    confirmButtonColor: '#e40601'
  });}
}

 actualizarTareas(dataIdarch){
  this.idiomasService.getTareasPrimaria(dataIdarch).subscribe((data : any)=>{
    this.primaryTask=data.tareas;
    this.validadorMatArchivo=[];
    this.validadorMatSelect=[];
    for(var p=0; p < this.primaryTask.length; p++){
      if(this.primaryTask[p].estatus){}else{
        this.primaryTask[p].estatus="No cumple";
      }
      let fechaTask=this.primaryTask[p].fechaCreacion.toString();
      let fechfechaTaskFin=this.primaryTask[p].fechaFin.toString();
      var currentDateTimeCentralTimeZone = new Date(this.primaryTask[p].fechaFin.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
      var date = new Date(currentDateTimeCentralTimeZone),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
      var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;
      this.primaryTask[p].fechaCreacion=fechaTask.substr(2,8);
      this.primaryTask[p].fechaFin=dateTmp;
      this.primaryTask[p]._id;
      if(this.primaryTask[p].archivos.length >0){
        this.validadorMatArchivo[p]=false;
      }
      else{
        this.validadorMatArchivo[p]=true;
      }
      if(this.primaryTask[p].observaciones==null){
        this.validadorMatSelect[p]=true;
      }else{
        if(this.primaryTask[p].observaciones.length > 0){
          this.validadorMatSelect[p]=false;
        }
        else {
          this.validadorMatSelect[p]=true;
        }
      }
    }
    setTimeout(()=>{Swal.close();},1200);
  });
}

private onPrimaryObs(event,idseccion,idTarea,iterador?){
  let statusObs:any;
  statusObs=event.target.value.trim();
  if(statusObs.length==0){

    Swal.fire({
      icon: 'warning',
      title: ''+this.mensajesTraducirTS.guarda_11, // advice 5
      confirmButtonColor: '#e40601'
    });
    let dataIdarch = {
      seccionId: idseccion,
      fechaDocumentador: this.fechaCertificar
    }
    this.validadorMatSelect[iterador] = true;
    this.actualizarTareas(dataIdarch);
  }else{

    this.typeEvent = event.target.value;
    this.validadorMatSelect[iterador] = false;
    this.data = {
      idSeccion : idseccion,
      idTarea: idTarea,
      fechaDocumentador: this.fechaCertificar,
      observaciones: this.typeEvent,
    };
    this.idiomasService.SaveTareaPrimaria(this.data).subscribe( (data : any) => {
      let dataIdarch = {
        seccionId: idseccion,
        fechaDocumentador: this.fechaCertificar
      }
      this.actualizarTareas(dataIdarch);

    });

  }
}

 seccion1 =[
   {
    tittle:"Video número 1",
    description:"The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from Japan. A small, agile dog that copes very well with mountainous terrain, the Shiba Inu was originally bred for hunting.",
    idVideo: 1,
   },{
    tittle:"Video número 2",
    description:"The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from Japan. A small, agile dog that copes very well with mountainous terrain, the Shiba Inu was originally bred for hunting.",
    idVideo: 2,
   },{
    tittle:"Video número 3",
    description:"The Shiba Inu is the smallest of the six original and distinct spitz breeds of dog from Japan. A small, agile dog that copes very well with mountainous terrain, the Shiba Inu was originally bred for hunting.",
    idVideo: 3,
   }
 ]
  openDialog(opcionData?:any): void {
    let dataModal: any;
    const dialogRef = this.dialog.open(DialogVideo, {
      width: '3500px', height: '600px',
      data: { opcion: opcionData }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }
}


@Component({
  selector: 'DialogVideo',
  templateUrl: 'dialog.component.html',
  styleUrls: ['./colaboradores.component.scss']
})
export class DialogVideo {
  private _unsubscribeAll: Subject<any>;
  constructor(
  private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  private translateSrv: TranslateService,
    public dialogRef: MatDialogRef<DialogVideo>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
      this._unsubscribeAll = new Subject();
      lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
    }
  onNoClick(): void {
    this.dialogRef.close();
  }
  mensaje:string = "Y";

}
